import React, { useState } from 'react';
import { Box, Button, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import { runKihemboAdminUpdate } from '../../utils/makeKihemboAdmin';

/**
 * Component to set up kihembowilb@gmail.com as a super admin
 */
const SuperAdminSetup = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleMakeSuperAdmin = async () => {
    setLoading(true);
    try {
      const updateResult = await runKihemboAdminUpdate();
      setResult(updateResult);
    } catch (error) {
      setResult({ success: false, message: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Super Admin Setup
        </Typography>
        
        <Typography variant="body1" paragraph>
          This will make <strong>kihembowilb@gmail.com</strong> a super admin with full permissions to create and approve artist accounts.
        </Typography>
        
        <Button 
          variant="contained" 
          color="primary"
          disabled={loading}
          onClick={handleMakeSuperAdmin}
          sx={{ mt: 2 }}
        >
          {loading ? <CircularProgress size={24} /> : 'Make Super Admin'}
        </Button>
        
        {result && (
          <Alert severity={result.success ? "success" : "error"} sx={{ mt: 2 }}>
            {result.message}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default SuperAdminSetup;
